export const categories = [
  { slug: 'wanghong-tafang', name: '网红塌房', icon: 'ri-user-unfollow-line', description: '网红翻车现场实录' },
  { slug: 'mingxing-liaotian', name: '明星聊天记录', icon: 'ri-message-2-line', description: '明星私密聊天泄露' },
  { slug: 'bozhu-fancha', name: '博主反差', icon: 'ri-contrast-2-line', description: '博主形象反差爆料' },
  { slug: '51chigua', name: '51吃瓜', icon: 'ri-emotion-happy-line', description: '51吃瓜黑料专区' },
  { slug: '17chigua', name: '17c吃瓜', icon: 'ri-fire-line', description: '17c吃瓜爆料专区' },
  { slug: 'meiri-dasai', name: '每日大赛', icon: 'ri-trophy-line', description: '每日吃瓜大赛精选' },
  { slug: 'shehui-redian', name: '社会热点', icon: 'ri-radar-line', description: '社会热点黑料追踪' },
  { slug: 'zhibo-fanche', name: '直播翻车', icon: 'ri-live-line', description: '直播间翻车实录' },
];

export const hotArticles = [
  {
    id: 1,
    title: '某千万粉丝网红私密视频流出，人设彻底崩塌',
    excerpt: '近日，一位拥有千万粉丝的知名网红因私密视频被曝光而陷入舆论漩涡，其精心打造的清纯人设一夜之间轰然倒塌...',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageSeq: 'hot-article-01',
    imageQuery: 'Dramatic breaking news scene with shattered glass effect and smartphone screen displaying scandal headlines, dark moody atmosphere with red and black tones, editorial photography style with intense lighting and deep shadows, cinematic composition, mysterious and urgent mood',
    author: '吃瓜小编',
    date: '2026-07-07',
    views: 128000,
    comments: 3421,
    isHot: true,
    isNew: false,
    tags: ['网红', '私密视频', '人设崩塌'],
  },
  {
    id: 2,
    title: '顶流男星聊天记录遭黑客泄露，内容令人震惊',
    excerpt: '某顶流男星的私人聊天记录昨日在暗网被公开，其中涉及多段私密对话和不雅内容，引发全网热议...',
    category: '明星聊天记录',
    categorySlug: 'mingxing-liaotian',
    imageSeq: 'hot-article-02',
    imageQuery: 'Leaked chat messages concept with glowing smartphone screens in dark room, redacted text overlays, mysterious hacker aesthetic with digital glitch effects, moody lighting with blue and red tones, cinematic cyber thriller atmosphere',
    author: '前线记者',
    date: '2026-07-06',
    views: 256000,
    comments: 8921,
    isHot: true,
    isNew: false,
    tags: ['明星', '聊天记录', '黑客'],
  },
  {
    id: 3,
    title: '知名美食博主被扒私下言行反差巨大',
    excerpt: '以温婉形象示人的知名美食博主，被前员工曝光私下辱骂员工、克扣工资等恶劣行为，粉丝纷纷表示难以置信...',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    imageSeq: 'hot-article-03',
    imageQuery: 'Two-face contrast concept with elegant restaurant facade on one side and messy back kitchen on the other, split composition, dramatic lighting revealing hidden truth, editorial photography with warm gold and dark shadow tones, storytelling visual',
    author: '爆料先锋',
    date: '2026-07-05',
    views: 189000,
    comments: 5632,
    isHot: true,
    isNew: false,
    tags: ['美食博主', '反差', '员工爆料'],
  },
  {
    id: 4,
    title: '电竞圈大地震！知名选手被爆假赛实锤',
    excerpt: '电竞圈再爆猛料，某知名战队核心选手被前队友实名举报参与假赛，涉及金额高达数百万，官方已介入调查...',
    category: '51吃瓜',
    categorySlug: '51chigua',
    imageSeq: 'hot-article-04',
    imageQuery: 'Esports competition scene with dramatic stadium lighting, referee whistle and red card visual metaphor, shocked spectator reactions, high contrast dramatic sports photography style with intense spotlight effects',
    author: '电竞观察员',
    date: '2026-07-07',
    views: 312000,
    comments: 12450,
    isHot: true,
    isNew: true,
    tags: ['电竞', '假赛', '实锤'],
  },
  {
    id: 5,
    title: '某综艺节目幕后黑幕曝光，剧本痕迹明显',
    excerpt: '一位曾参与多档热门综艺的幕后工作人员匿名爆料，揭露了节目组操纵选手命运、刻意制造冲突的内幕...',
    category: '17c吃瓜',
    categorySlug: '17chigua',
    imageSeq: 'hot-article-05',
    imageQuery: 'TV production studio behind the scenes with script papers scattered on floor, spotlight revealing hidden crew members, dramatic theatrical lighting with warm stage lights and dark backstage shadows, documentary photography style',
    author: '综艺内线',
    date: '2026-07-04',
    views: 145000,
    comments: 4102,
    isHot: false,
    isNew: false,
    tags: ['综艺', '黑幕', '剧本'],
  },
  {
    id: 6,
    title: '某带货主播直播间翻车，假货当场被揭穿',
    excerpt: '一场直播带货中，某知名主播推销的"大牌"化妆品被观众当场验货发现为假货，场面一度极其尴尬...',
    category: '直播翻车',
    categorySlug: 'zhibo-fanche',
    imageSeq: 'hot-article-06',
    imageQuery: 'Live streaming setup with shocked streamer expression, broken product packaging on desk, dramatic red alert lighting, chaotic studio scene with equipment falling, intense editorial photography with high contrast shadows',
    author: '直播观察员',
    date: '2026-07-06',
    views: 201000,
    comments: 7834,
    isHot: true,
    isNew: true,
    tags: ['直播', '假货', '翻车'],
  },
  {
    id: 7,
    title: '娱乐圈大佬聚会录音流出，内容信息量巨大',
    excerpt: '一段疑似娱乐圈多位大佬私下聚会的录音昨日在网络上疯传，其中涉及多起行业潜规则和不可告人的交易...',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    imageSeq: 'hot-article-07',
    imageQuery: 'Exclusive private dinner scene in upscale restaurant private room, audio recorder on table as focal point, dim atmospheric lighting with warm chandelier glow, mysterious and secretive mood, cinematic photography with shallow depth of field',
    author: '深度调查',
    date: '2026-07-03',
    views: 378000,
    comments: 15672,
    isHot: true,
    isNew: false,
    tags: ['娱乐圈', '录音', '潜规则'],
  },
  {
    id: 8,
    title: '某知名品牌代言人涉嫌偷税漏税被调查',
    excerpt: '据知情人士透露，某国际知名品牌的代言人因涉嫌巨额偷税漏税正在接受相关部门调查，品牌方已紧急暂停所有合作...',
    category: '51吃瓜',
    categorySlug: '51chigua',
    imageSeq: 'hot-article-08',
    imageQuery: 'Corporate investigation scene with documents and tax forms spread on modern office desk, dramatic lighting through window blinds creating shadow patterns, serious and tense atmosphere, editorial business photography with cool tones',
    author: '财经记者',
    date: '2026-07-07',
    views: 167000,
    comments: 5102,
    isHot: false,
    isNew: true,
    tags: ['代言人', '偷税漏税', '调查'],
  },
];

export const dailyCompetition = {
  title: '今日吃瓜大赛',
  description: '每天评选最劲爆的黑料爆料，投票选出你心中的"今日瓜王"',
  entries: [
    {
      id: 1,
      title: '某女星被拍到深夜与神秘男子同回公寓',
      votes: 45230,
      imageSeq: 'comp-entry-01',
      imageQuery: 'Paparazzi night photography style, celebrity couple walking into apartment building entrance, blurred motion, dim street lamp lighting, mysterious and secretive atmosphere, urban night scene with cinematic grain',
    },
    {
      id: 2,
      title: '知名rapper疑似新歌diss多位圈内好友',
      votes: 38720,
      imageSeq: 'comp-entry-02',
      imageQuery: 'Recording studio booth with microphone and lyric sheets, dramatic spotlight on empty mic stand, urban music production aesthetic with warm amber tones, creative tension atmosphere, editorial photography',
    },
    {
      id: 3,
      title: '某富二代炫富视频意外暴露家族灰色产业',
      votes: 52100,
      imageSeq: 'comp-entry-03',
      imageQuery: 'Luxury lifestyle collapse concept, expensive items falling like dominoes, dramatic lighting with gold and shadow contrast, opulent interior in background going dark, editorial social commentary photography',
    },
  ],
};

export const userComments = [
  {
    id: 1,
    username: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20internet%20user%20avatar%20with%20watermelon%20slice%20icon%2C%20minimalist%20flat%20illustration%20style%2C%20warm%20red%20and%20green%20tones%2C%20simple%20cute%20design%20on%20white%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    title: '这瓜保熟！太劲爆了',
    content: '每天蹲守吃瓜网已经成了我的日常，这里的爆料速度比微博还快，内容也够劲爆。小编加鸡腿！',
    date: '2026-07-07',
  },
  {
    id: 2,
    username: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20character%20holding%20popcorn%20bucket%20at%20night%2C%20minimalist%20flat%20design%20style%2C%20dark%20background%20with%20warm%20yellow%20accent%2C%20playful%20illustration%20for%20social%20media%20profile&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    title: '信息量太大了，需要消化',
    content: '今天的爆料一个比一个猛，感觉娱乐圈要变天了。坐等更多实锤！',
    date: '2026-07-06',
  },
  {
    id: 3,
    username: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20geometric%20owl%20character%20reading%20newspaper%2C%20minimalist%20flat%20vector%20illustration%2C%20wise%20and%20calm%20expression%2C%20warm%20brown%20and%20beige%20tones%2C%20clean%20design%20on%20white%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    title: '内容不错，但要注意核实',
    content: '爆料的时效性确实没话说，但有时候标题有点夸张。希望编辑能更注重事实核查。',
    date: '2026-07-05',
  },
  {
    id: 4,
    username: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Playful%20cartoon%20magnifying%20glass%20detective%20character%2C%20minimalist%20flat%20design%2C%20vibrant%20coral%20and%20white%20colors%2C%20energetic%20illustration%20style%2C%20simple%20cute%20mascot%20on%20light%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    title: '全网最快黑料爆料平台',
    content: '对比了好几个吃瓜平台，还是这里更新最快最全。推荐给所有爱吃瓜的朋友！',
    date: '2026-07-07',
  },
  {
    id: 5,
    username: '互联网考古学家',
    avatar: 'https://readdy.ai/api/search-image?query=Cartoon%20explorer%20character%20with%20hat%20and%20backpack%20holding%20map%2C%20minimalist%20flat%20vector%20art%2C%20warm%20earthy%20tones%2C%20adventurous%20and%20curious%20expression%2C%20clean%20simple%20design%20on%20white%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 4,
    title: '爆料质量越来越高了',
    content: '最近的深度调查文章写得很有水平，不只是一味追求劲爆，还有分析有深度。继续加油！',
    date: '2026-07-04',
  },
  {
    id: 6,
    username: '瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20cartoon%20watermelon%20character%20wearing%20sunglasses%2C%20minimalist%20flat%20design%20style%2C%20refreshing%20green%20and%20pink%20tones%2C%20cool%20and%20trendy%20illustration%2C%20simple%20cute%20design%20on%20white%20background&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 5,
    title: '忠实粉丝，每天都来看',
    content: '从51吃瓜时代就开始追了，现在内容越来越丰富。希望吃瓜网越做越好！',
    date: '2026-07-03',
  },
];

export const brandInfo = {
  name: '黑料爆料吃瓜网',
  slogan: '全网热门黑料爆料，一网打尽',
  description: '黑料爆料吃瓜网成立于2023年，是国内领先的黑料爆料资讯聚合平台。我们致力于为吃瓜群众提供最新、最全、最劲爆的黑料爆料内容，覆盖网红塌房、明星聊天记录泄露、博主反差视频、51吃瓜黑料爆料、17c吃瓜黑料爆料等多个领域。',
  founded: '2023年',
  email: 'hello@mengwenquda.cn',
  address: '北京市朝阳区望京SOHO',
  phone: '400-888-6666',
};